export const formatName = (user) => {
    return [user.firstName, user.lastName].filter(Boolean).join(' ');
};
//# sourceMappingURL=formatters.js.map